module.exports = __webpack_public_path__ + "static/media/signal.1c5273a2.svg";